import SellytLogo from '@/assets/svg/sellyt-logo.svg?react';

export const HeroEmblem = () => (
  <div className="hero-emblem" aria-hidden>
    <span className="emblem-orbit emblem-orbit-3" />
    <span className="emblem-orbit emblem-orbit-2" />
    <span className="emblem-orbit emblem-orbit-1" />
    <span className="emblem-spark emblem-spark-1" />
    <span className="emblem-spark emblem-spark-2" />
    <span className="emblem-spark emblem-spark-3" />
    <span className="emblem-token">
      <SellytLogo className="emblem-logo" aria-hidden />
    </span>
    <span className="emblem-coin">
      <span className="emblem-coin-glow" />
      <span className="emblem-coin-amt">₦</span>
    </span>
  </div>
);
